import { ComponentProps } from "react";
import { Button } from "../../button";
import "./under-age.scss";
import { useAppSelector } from "../../../../hooks/hooks";
import {
  selectLanguage,
  selectTranslations,
} from "../../../data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../../utils/translation";

export interface UnderAgeProps extends ComponentProps<"div"> {
  onButtonClick: () => void;
  buttonText?: string;
}

export function UnderAge({
  onButtonClick,
  buttonText,
  ...props
}: UnderAgeProps) {
  const lang = useAppSelector(selectLanguage);
  const translations = useAppSelector(selectTranslations);

  return (
    <div className="under-age-modal modal-content" {...props}>
      <div className="top-area">
        <div className="title">
          {checkTranslationKey(
            translations[lang]?.Access_not_available,
            "Access not available!"
          )}
        </div>
        <div className="message-icon">
          <img src="../img/icns/under-age.png" alt="" width="80em" />
        </div>
        <div className="message">
          {checkTranslationKey(
            translations[lang]?.Under_age_activation_failed,
            "Dear customer, the KYC status of your number or your age does not meet the Terms and Conditions of the Battle Up service. For more information or assistance, contact customer support at 19333 or visit an Africell store."
          )}
        </div>
      </div>
      <div className="bottom-area">
        <Button onClick={onButtonClick} buttonType="success">
          {buttonText || checkTranslationKey(translations[lang]?.OK, "OK")}
        </Button>
      </div>
    </div>
  );
}

export default UnderAge;
